import declare from "dojo/_base/declare";
import { ButtonEnum } from "designSystem/types/button-types";
import Widget from "csi/wizard/Widget";

const {
	BUTTON_FINISH_GO,
	BUTTON_NEXT_PAGE,
} = ButtonEnum;

const NewAffectedItem = declare(Widget, {

	/**
	 * @override
	 * Don't show next button if not first page, remove the Finish and Go button.
	 */
	canShowButton(idAction: String): boolean {
		const page = this.getSelectedPage();
		const index = this.getIndexOfPage(page);

		if (idAction === BUTTON_NEXT_PAGE) {
			return index === 0;
		}

		return (idAction === BUTTON_FINISH_GO) ? false : this.inherited<boolean>(arguments);
	},
});

export = NewAffectedItem;